export default {"src":"/_next/static/media/pencil-ruler.9cc9a34d.svg","height":22,"width":22,"blurWidth":0,"blurHeight":0};